import HeroLinks from './HeroLinks';

export default HeroLinks;
